import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-black border-t border-white/5 relative z-10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-1 mb-6">
              <Logo />
              <span className="brand-wordmark">CYNOPSIS</span>
            </div>
            <p className="text-sm text-zinc-400 leading-relaxed max-w-sm mb-6">
              Built for the student who was told no. Accessible, structured filmmaking education for the next generation of Indian creators.
            </p>
            <div className="film-strip w-24"></div>
          </div>

          <div>
            <h3 className="text-xs font-bold text-white tracking-[0.25em] uppercase mb-5">Learn</h3>
            <ul className="space-y-3">
              <li><Link to="/courses" data-testid="footer-courses-link" className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors">Courses</Link></li>
              <li><Link to="/masterclasses" data-testid="footer-masterclasses-link" className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors">Masterclasses</Link></li>
              <li><Link to="/newsletter" data-testid="footer-newsletter-link" className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors">Newsletter</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold text-white tracking-[0.25em] uppercase mb-5">Studio</h3>
            <ul className="space-y-3">
              <li><Link to="/about" data-testid="footer-about-link" className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors">About</Link></li>
              <li><Link to="/contact" data-testid="footer-contact-link" className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors">Contact</Link></li>
              <li>
                <Link
                  to="/#waitlist"
                  data-testid="footer-faculty-link"
                  className="text-sm text-zinc-400 hover:text-[#C8102E] transition-colors"
                >
                  Join the waitlist
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-xs text-zinc-500 tracking-wider">© 2026 CYNOPSIS. ALL RIGHTS RESERVED.</p>
          <p className="text-xs text-zinc-600 font-serif italic">"Your shot at cinema."</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
